<template>
  <custom-dialog width="500px" :title="$t('base_resetPwdDialog.xiu_gai_mi_ma')" :showClose="model.type !== 'window'" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <p v-if="model.type === 'window'" style="font-size: 13px; margin-bottom: 12px; color: #0d9ae0">{{ $t('base_resetPwdDialog.ndmmyyglyzdlbxcxszmm') }}</p>
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_resetPwdDialog.jiu_mi_ma')" prop="originalPwd">
              <el-input v-model="form.originalPwd" :type="passwordShow ? 'text' : 'password'">
                <i
                  slot="suffix"
                  style="font-size: 18px; display: inline-block; transform: translateY(1px); margin-right: 5px"
                  class="icon"
                  :class="[passwordShow ? 'icon-xianshi' : 'icon-yincang']"
                  @click="passwordShow = !passwordShow"
                ></i>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_resetPwdDialog.xin_mi_ma')" prop="newPwd">
              <el-input v-model="form.newPwd" :type="passwordShow1 ? 'text' : 'password'" :placeholder="$t('base_resetPwdDialog.mm816wbxbhszfhzmrylz')">
                <i
                  slot="suffix"
                  style="font-size: 18px; display: inline-block; transform: translateY(1px); margin-right: 5px"
                  class="icon"
                  :class="[passwordShow1 ? 'icon-xianshi' : 'icon-yincang']"
                  @click="passwordShow1 = !passwordShow1"
                ></i>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_resetPwdDialog.que_ren_xin_mi_ma')" prop="confirmPwd">
              <el-input v-model="form.confirmPwd" :type="passwordShow2 ? 'text' : 'password'" :placeholder="$t('base_resetPwdDialog.qzsrycxmm')">
                <i
                  slot="suffix"
                  style="font-size: 18px; display: inline-block; transform: translateY(1px); margin-right: 5px"
                  class="icon"
                  :class="[passwordShow2 ? 'icon-xianshi' : 'icon-yincang']"
                  @click="passwordShow2 = !passwordShow2"
                ></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="model.type !== 'window'" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="changePwd">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      passwordShow: false,
      passwordShow1: false,
      passwordShow2: false,
      appName: '',
      parentName: '',
      form: {
        originalPwd: '',
        newPwd: '',
        confirmPwd: '',
      },
      langKeyId: '',
      // 所选分组list
      treeOptionList: [],
    };
  },
  mounted() {},
  computed: {
    rules() {
      return {
        originalPwd: {
          required: true,
          message: this.$t('base_resetPwdDialog.qsrjmm'),
        },
        newPwd: {
          required: true,
          validator: (rule, value, callback) => {
            const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
            if (!value) {
              callback(new Error(this.$t('base_resetPwdDialog.qzcsrmm')));
            } else if (value.toString().length < 8 || value.toString().length > 16) {
              callback(new Error(this.$t('base_resetPwdDialog.mmcdw816gzf')));
            } else if (!reg.test(value.toString())) {
              callback(new Error(this.$t('base_resetPwdDialog.bxbhszfhzmrylz')));
            } else if (value === this.form.originalPwd) {
              callback(new Error(this.$t('base_resetPwdDialog.xmmyjmmbnxt')));
            } else {
              callback();
            }
          },
          trigger: 'blur',
        },
        confirmPwd: {
          required: true,
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error(this.$t('base_resetPwdDialog.qzcsrmm')));
            } else if (value !== this.form.newPwd) {
              callback(new Error(this.$t('base_resetPwdDialog.lcsrmmbyz')));
            } else {
              callback();
            }
          },
          trigger: 'blur',
        },
      };
    },
  },
  methods: {
    // 修改登录密码
    changePwd: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(
          apis.UpdatePwd,
          Object.assign({}, this.form, {
            originalPwd: this.encrypt(this.form.originalPwd),
            newPwd: this.encrypt(this.form.newPwd),
            confirmPwd: this.encrypt(this.form.confirmPwd),
          }),
          true
        )
          .then(() => {
            this.visible = false;
            this.$store.commit('PSWDLOGINCHANGE', '0');
            this.$message({
              message: this.$t('Common.com_modify_success'),
              type: 'success',
            });
            // 跳转登录
            this.$store.commit('LOGINOUT');
            Cookies.remove('loginName', { path: '/' });
            Cookies.remove('token', { path: '/' });
            Cookies.remove('nonMetric', { path: '/' });
            Cookies.remove('tokenTimeOut', { path: '/' });
            this.$router.replace({ path: '/login', query: {} });
          })
          .catch(() => {});
      });
    },
  },
};
</script>

<style lang="scss"></style>
